import { safeLocalStorage } from './safeStorage';

export const saveToStore = (name: string, data: string) => {
  safeLocalStorage.setItem(name, data);
};

export const getItemFromStore = (name: string): string | null => {
  return safeLocalStorage.getItem(name);
};
